<form
  (ngSubmit)="onSigniup()"
  [formGroup]="form"
  autocomplete="off"
  class="formSignUp w-100 fadeIn"
>
  <mat-form-field>
    <input
      matInput
      name="email"
      placeholder="{{ 'k000079' | translate }}"
      formControlName="email"
      autocomplete="new-email"
      class="inp-item"
      (keyup)="resetmail()"
    />
    <!-- Token: Email -->
  </mat-form-field>

  <mat-form-field>
    <input
      matInput
      name="password"
      placeholder="{{ 'k000002' | translate }}"
      [type]="hide ? 'password' : 'text'"
      autocomplete="new-password"
      formControlName="password"
      class="inp-item"
      maxlength="30"
      (keyup)="formValidation()"
    />

    <mat-icon
      matSuffix
      (click)="hide = !hide"
      [attr.aria-label]="'Hide password'"
      [attr.aria-pressed]="hide"
    >
      <fa-icon icon="{{ hide ? 'eye' : 'eye-slash' }}" size="xs"></fa-icon>
    </mat-icon>
  </mat-form-field>
  <div class="contentValidatons">
    <small>
      <fa-icon
        [hidden]="!errorRealMail"
        class="red"
        [icon]="['fal', 'circle-xmark']"
      ></fa-icon>
      <fa-icon
        [hidden]="errorRealMail"
        class="green"
        [icon]="['fal', 'circle-check']"
      ></fa-icon>
      {{ 'k002465' | translate }}
      <!-- token: Real email -->
    </small>
    <small>
      <fa-icon
        [hidden]="!errorMinLength"
        class="red"
        [icon]="['fal', 'circle-xmark']"
      ></fa-icon>
      <fa-icon
        [hidden]="errorMinLength"
        class="green"
        [icon]="['fal', 'circle-check']"
      ></fa-icon>
      {{ 'k002466' | translate }}
      <!-- token: Minimum 8 characters -->
    </small>
    <small
      ><fa-icon
        [hidden]="!errorUpcase"
        class="red"
        [icon]="['fal', 'circle-xmark']"
      ></fa-icon>
      <fa-icon
        [hidden]="errorUpcase"
        class="green"
        [icon]="['fal', 'circle-check']"
      ></fa-icon>
      {{ 'k002467' | translate }}
      <!-- token: Minimum one uppercase character -->
    </small>
    <small>
      <fa-icon
        [hidden]="!errorDowncase"
        class="red"
        [icon]="['fal', 'circle-xmark']"
      ></fa-icon>
      <fa-icon
        [hidden]="errorDowncase"
        class="green"
        [icon]="['fal', 'circle-check']"
      ></fa-icon>
      {{ 'k002468' | translate }}
      <!-- token: Minimum one lowercase character -->
    </small>
    <small>
      <fa-icon
        [hidden]="!errorDigi"
        class="red"
        [icon]="['fal', 'circle-xmark']"
      ></fa-icon>
      <fa-icon
        [hidden]="errorDigi"
        class="green"
        [icon]="['fal', 'circle-check']"
      ></fa-icon>
      {{ 'k002469' | translate }}
      <!-- token: Minimum one number -->
    </small>
    <small>
      <fa-icon
        [hidden]="!errorChart"
        class="red"
        [icon]="['fal', 'circle-xmark']"
      ></fa-icon>
      <fa-icon
        [hidden]="errorChart"
        class="green"
        [icon]="['fal', 'circle-check']"
      ></fa-icon>
      {{ 'k002470' | translate }}
      <!-- token:  Minimum one special character -->
      <fa-icon
      class="ml-1 pointer blue2"
      icon="info-circle"
      (click)="viewHintHelp($event)"
    ></fa-icon>
    </small>
  </div>
  <mat-checkbox
    class="checkConsent mt-3"
    name="checkConsent"
    formControlName="checkConsent"
  >
    <small>
      {{ consent }}
      <!-- token: Consent: Communication of personal data to entities belonging to TechRules Group -->
    </small>
  </mat-checkbox>
  <small *ngIf="mailExist" class="mt-3 red w-100 text-center">{{
    'k002459' | translate
  }}</small>
  <!-- Token: This email already exists in our database -->
  <button
    mat-raised-button
    class="signUpSubmit buttonPortal lg align-self-center"
    type="submit"
    [disabled]="form.invalid"
  >
    <span *ngIf="!showfaSpinner">{{ 'k002460' | translate }}</span
    ><!-- Token: Create my account -->

    <fa-icon [icon]="faSpinner" [spin]="true" *ngIf="showfaSpinner"></fa-icon>
  </button>
  <small class="mt-3 text-center" [innerHTML]="'k002461' | translate"></small>
  <!-- Token: I'm 18 or older and I agree with Basic GDPR information and Privacy
  policy -->
</form>
